/* template */
<template><div v-on="$listeners" :class='["mpx-root-view","host-_863ba266"]'><div :class='["dialog-confirm-passenger-demo"]'><cube-button @_click="onClickDialog">Dialog - confirm</cube-button><cube-dialog ref="__mpx_ref_dialogConfirm__" type="confirm" title="我是标题要精简" content="正文行文符合话术规范，表意清晰可多行展示，单行居中对齐，多行居左" confirm-btn="引导文案" cancel-btn="按钮文案" :class='["custom-dialog-confirm"]'></cube-dialog></div></div></template>
/* styles */
<style lang="stylus" mpxStyleOptions='{"mid":"_863ba266"}'>
.custom-dialog-confirm .cube-dialog-confirm .cube-dialog-btns .cube-dialog-btn:first-child
  color #444
</style>

/* json */
/* script */
<script>
  import { processComponentOption, getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  var wxsModules = {}
  global.currentModuleId = "_863ba266"
  global.currentSrcMode = "wx"
  global.currentInject = {"moduleId":"_863ba266"}
  /** script content **/
  require("./dialog-confirm.mpx.js?isComponent&outputPath=components%2Fdialog-confirm863ba266%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./dialog-confirm.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fdialog-confirm863ba266%2Findex&type=script")

  export default processComponentOption({
    option: global.__mpxOptionsMap["_863ba266"],
    ctorType: "component",
    outputPath: "components/dialog-confirm863ba266/index",
    pageConfig: {},
    // @ts-ignore
    componentsMap: {'cube-button':getComponent(require("../../../packages/mpx-cube-ui/src/components/button/index.mpx?isComponent&outputPath=components%2Findex7752a2b9%2Findex")),'cube-dialog':getComponent(require("../../../packages/mpx-cube-ui/src/components/dialog/index.mpx?isComponent&outputPath=components%2Findex8b435562%2Findex"))},
    componentGenerics: {},
    genericsInfo: undefined,
    wxsMixin: getWxsMixin(wxsModules),
    hasApp: true
  })
</script>